





















import { Component, Vue, Prop } from 'vue-property-decorator';
import CountCard from './index.vue';

@Component({
  components: { CountCard }
})
export default class CountCardSimpleGrid extends Vue {
  // 一行展示个数
  @Prop()
  columnsNum: number;
  @Prop()
  cards!: Array<{
    title: string;
    tip: string;
    count: string; // 展示数据
    countColor: string; // 字体颜色, 支持primary、success、warning、error、gray和色值（#xxxxxx）
    icon: string;
    echarts: any;
  }>;

  isHide: boolean = false;

  // 一行展示个数， 内部兼容计算（默认数据全部一行展示）
  get columnsLen() {
    return this.columnsNum || this.cards.length || 1;
  }
  // 元素展示宽度
  get widthPrecent() {
    return `${Math.floor(10000 / this.columnsLen) / 100}%`;
  }

  // 显示隐藏操作
  toggleHide() {
    this.isHide = !this.isHide;
    this.$nextTick(() => {
      const myEvent = new Event('resize');
      window.dispatchEvent(myEvent);
    });
  }
}
